import { render, staticRenderFns } from "./SPagination.vue?vue&type=template&id=b8fb33b4&scoped=true&"
import script from "./SPagination.vue?vue&type=script&lang=js&"
export * from "./SPagination.vue?vue&type=script&lang=js&"
import style0 from "./SPagination.vue?vue&type=style&index=0&id=b8fb33b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fb33b4",
  null
  
)

export default component.exports